import "./IdvStatus.css";
import { Tag } from "primereact/tag";

const getIdvTagSeverity = (status) => {
  switch (status) {
    case "approved":
      return "success";
    case "rejected":
      return "danger";
    case "pending":
      return "warning";
    case "retry":
      return "info";
    case "expired":
      return "danger"
    default:
      return null;
  }
};

const getIdvTagIcon = (status) => {
  switch (status) {
    case "approved":
      return (
        <>
          <i className="pi pi-id-card" style={{marginRight:"8px"}}/>
          <i className="pi pi-exclamation-circle" />
        </>
      );

    case "rejected":
      return (
        <>
          <i className="pi pi-id-card" style={{marginRight:"8px"}}/>
          <i className="pi pi-times-circle" />
        </>
      );
    case "retry":
      return (
        <>
          <i className="pi pi-id-card" style={{marginRight:"8px"}}/>
          <i className="pi pi-sync" />
        </>
      );
    
    case "expired":
      return (
        <>
          <i className="pi pi-id-card" style={{marginRight:"8px"}}/>
          <i className="pi pi-exclamation-circle" />
        </>
    );

    default:
      return (
        <>
          <i className="pi pi-id-card" style={{marginRight:"8px"}}/>
          <i className="pi pi-clock" />
        </>
      );

  }
};

export const IdvStatus = ({ status }) => {
  const cleanStatus = status?.trim().toLowerCase();

  const validStatuses = ["approved", "rejected", "pending", "retry", "expired"];
  const isValid = validStatuses.includes(cleanStatus);

  if (!isValid) {
    return (
      <span className="idv-tag-disabled" title={`ID verification: NOT STARTED`}>
        <i className="pi pi-id-card" />
        <i className="pi pi-exclamation-circle" />
      </span>
    );
  }

  return (
    <Tag
      icon={getIdvTagIcon(cleanStatus)}
      severity={getIdvTagSeverity(cleanStatus)}
      style={{ cursor: "default" }}
      title={`ID verification: ${cleanStatus.toUpperCase()}`}
    />
  );
};